import React from "react";
import {
  Smartphone,
  Laptop,
  Tablet,
  Monitor,
  HardDrive,
  ShieldCheck,
  Gamepad2,
  CheckCircle2,
  ArrowUpRight,
} from "lucide-react";
import { services } from "../mock";

const iconMap = { Smartphone, Laptop, Tablet, Monitor, HardDrive, ShieldCheck, Gamepad2 };

const Services = () => {
  return (
    <section id="services" className="relative py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex items-end justify-between gap-6 flex-wrap reveal">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-emerald-300/80">
              Υπηρεσίες
            </div>
            <h2 className="mt-2 text-3xl md:text-4xl lg:text-5xl font-extrabold text-white tracking-tight">
              Μια λύση για{" "}
              <span className="text-emerald-400">κάθε</span> βλάβη
            </h2>
          </div>
          <p className="max-w-md text-emerald-50/70">
            Από σπασμένες οθόνες ως καμένες μητρικές. Εγγύηση 6 μηνών
            σε κάθε επισκευή.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s, i) => {
            const Icon = iconMap[s.icon] || Smartphone;
            return (
              <div key={s.id} className="pcb-card p-6 reveal group">
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-lg bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center group-hover:bg-emerald-500/20 transition-colors">
                    <Icon className="w-6 h-6 text-emerald-400" />
                  </div>
                  <span className="text-[10px] font-mono px-2 py-1 rounded border border-red-500/40 text-red-300">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="mt-5 text-xl font-bold text-white">{s.title}</h3>
                <p className="mt-2 text-sm text-emerald-50/65 leading-relaxed">
                  {s.desc}
                </p>
                <ul className="mt-4 space-y-2">
                  {s.items.map((it) => (
                    <li
                      key={it}
                      className="flex items-start gap-2 text-sm text-emerald-50/80"
                    >
                      <CheckCircle2 className="w-4 h-4 text-emerald-400 mt-0.5 shrink-0" />
                      {it}
                    </li>
                  ))}
                </ul>
                <div className="mt-6 pt-4 border-t border-emerald-900/50 flex items-center justify-between">
                  <span className="text-emerald-300 font-mono text-sm">
                    {s.price}
                  </span>
                  <a
                    href="#contact"
                    className="inline-flex items-center gap-1 text-sm text-white/90 hover:text-emerald-300 transition-colors"
                  >
                    Προσφορά <ArrowUpRight className="w-4 h-4" />
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
